import script from "./Popover.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popover.vue?vue&type=script&setup=true&lang=ts"

import "./Popover.vue?vue&type=style&index=0&id=eb3aad5a&lang=scss"

const __exports__ = script;

export default __exports__